/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Actions/view.blocks to change it.
import CreateFolder from './CreateFolder/index'
import CreateVirtualFile from './CreateVirtualFile/index'
import ImportFromDevices from './ImportFromDevices/index'
import React from 'react'
import Upload from './Upload/index'
import styles from './view.module.css'
import useIsMedia from 'Simple/hooks/useIsMedia'



/** @type {import('Simple/types.js').View} */
export default function Actions({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Documents/Navigation/Actions"
  
}) {
  let isMedia = useIsMedia()
  return (<React.Fragment
>
<div
  data-testid="Actions.Horizontal"
  data-view-path={viewPath}
 style={{'--ml-5-AjnkD': isMedia.mobile ? "auto" : "0px",'--jc-1-AjnkD': isMedia.mobile ? "flex-start" : "end",'--w-2-AjnkD': isMedia.mobile ? "120px" : "auto",'--mw-3-AjnkD': isMedia.mobile ? "120px" : "100%",'--ox-4-AjnkD': isMedia.mobile ? "auto" : "hidden"}}
 className={`views-block ${styles.Horizontal}`}
>
<Upload
  viewPath={`${viewPath}/Upload`}
/>
<ImportFromDevices
  viewPath={`${viewPath}/ImportFromDevices`}
/>
<CreateFolder
  viewPath={`${viewPath}/CreateFolder`}
/>
<CreateVirtualFile
  viewPath={`${viewPath}/CreateVirtualFile`}
/>
</div>
{children}
</React.Fragment>)
}